// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const tabs = gql`
  query tabs($name: String!, $node: String!) {
    tabs(name: $name, node: $node)
      @rest(
        type: "LiveDataPanelCollectionTab"
        path: "livedata/collections/{args.name}/tabs?node={args.node}&template={args.name}"
      ) {
      id
      name
      link
      panelBean
      uri
      externalUrl
    }
  }
`;

export default tabs;
